module.exports = __webpack_public_path__ + "media/images/telefono_corona2-b496400e0ed5dfc089af9f2ee72a82e6.png";